import { Box, TextField, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import useAPI from "../../../../api/hooks/useAPI";
import useIsIntegrated from "../../../../api/hooks/useIsIntegrated";
import { integrationKeys } from "../../../../api/queryKeys";
import ContainedButton from "../../../../components/buttons/ContainedButton";
import LoadingIcon from "../../../../components/LoadingIcon";
import { Toast } from "../../../../components/Toast";
import Guideline from "../components/Guideline";
import GuidelineStep from "../components/GuidelineStep";
import GuidelineStepByStep from "../components/GuidelineStepByStep";
import { ReactComponent as LayerXLogo } from "../logos/LayerX.svg";
const LAYERX_CODE_NAME = "layerx";

export default function LayerXIntegration() {
  const queryClient = useQueryClient();
  const [searchParams] = useSearchParams();
  const [apiToken, setApiToken] = useState("");
  const { registerLayerXIntegration } = useAPI();
  const [registerIsLoading, setRegisterIsLoading] = useState(false);
  const { isIntegrated, isIntegratedLoading } =
    useIsIntegrated(LAYERX_CODE_NAME);

  const guideMode = searchParams.has("viewonly");

  const onSubmit = async () => {
    setRegisterIsLoading(true);
    try {
      await registerLayerXIntegration(apiToken);
      queryClient.invalidateQueries({
        queryKey: integrationKeys.all,
      });
      Toast.success("LayerX registered successfully");
    } catch (error) {
      if (error.response) {
        Toast.error(`Something went wrong: ${error.response.data.detail}`);
      } else {
        Toast.error("An error occurred while processing the request.");
      }
    } finally {
      setRegisterIsLoading(false);
    }
  };

  return (
    <Box>
      <Guideline
        title={isIntegrated ? "" : "LayerX integration instructions"}
        image={LayerXLogo}
        iconBorderRadius={0}
        name={LAYERX_CODE_NAME}
        content={
          isIntegratedLoading ? (
            <LoadingIcon size={25} />
          ) : isIntegrated && !guideMode ? (
            <Box>
              <Typography variant={"h4"}>LayerX is registered!</Typography>
            </Box>
          ) : (
            <Box>
              <GuidelineStepByStep>
                <GuidelineStep title="Generate API Token" />
                <GuidelineStep title="Enter the API Token">
                  <Box
                    width={700}
                    display="flex"
                    flexDirection="column"
                    gap={2}
                  >
                    <TextField
                      placeholder="API Token"
                      fullWidth
                      type="text"
                      value={apiToken}
                      onChange={(e) => setApiToken(e.target.value)}
                      disabled={guideMode}
                    />
                  </Box>
                  <ContainedButton
                    onClick={onSubmit}
                    size="small"
                    color="primary"
                    disabled={guideMode || !apiToken}
                    loading={registerIsLoading}
                  >
                    Connect
                  </ContainedButton>
                </GuidelineStep>
              </GuidelineStepByStep>
            </Box>
          )
        }
      />
    </Box>
  );
}
